// @flow
'use strict';

import * as React from 'react';

import type { IEmitente } from '../types';
import { tipoDocumento } from './abas_informacoes';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

type EmitenteProps = {
  emitente : IEmitente,
};

export default function Emitente({ emitente } : EmitenteProps) {
  return (
      <div className="tab-pane active">
        <h3>Emitente</h3>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="cnpj" type="documento" width="50%">{ tipoDocumento(emitente) }</ColumnDetalhes>
          <ColumnDetalhes field="nome" width="50%">Nome / Razão Social</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="fantasia" width="50%">Nome Fantasia</ColumnDetalhes>
          <ColumnDetalhes field="endereco" width="50%">Endereço</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="bairro" width="50%">Bairro</ColumnDetalhes>
          <ColumnDetalhes field="municipio" width="50%">Município</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="uf" width="50%">UF</ColumnDetalhes>
          <ColumnDetalhes field="cep" type="cep" width="50%">CEP</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="pais" width="50%">País</ColumnDetalhes>
          <ColumnDetalhes field="telefone" width="50%">Telefone</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="inscricaoEstadual" width="50%">Inscrição Estadual</ColumnDetalhes>
          <ColumnDetalhes field="iest" width="50%">IE Subst. Trib.</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="inscricaoMunicipal" width="50%">Inscrição Municipal</ColumnDetalhes>
          <ColumnDetalhes field="cnae" width="50%">CNAE</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente }>
          <ColumnDetalhes field="regimeTributario" width="50%">Regime Tributário</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}
